export default "__VITE_ASSET__Dw3nRh_7__"